module.exports = __webpack_public_path__ + "static/media/deepThinking.db3cd0b6.png";